import { useLocation } from "react-router-dom";
import { Compass, MicrosoftOutlookLogo } from "@phosphor-icons/react";
import { API } from "@/lib/api";

export default function Login() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const err = params.get("error");

  const startLogin = () => {
    // Server-side OAuth: hit backend which redirects to Microsoft
    window.location.href = `${API}/auth/microsoft/login`;
  };

  return (
    <div className="min-h-screen bg-[#FAFAF7] flex items-center justify-center p-6" data-testid="login-page">
      <div className="max-w-md w-full">
        <div className="flex items-center gap-3 mb-10">
          <div className="w-10 h-10 bg-neutral-900 grid place-items-center rounded">
            <Compass size={22} weight="fill" color="white" />
          </div>
          <div>
            <div className="font-display text-3xl leading-none">Prospexus</div>
            <div className="overline mt-1">Outreach OS</div>
          </div>
        </div>

        <div className="border border-neutral-200 rounded-md bg-white p-10">
          <div className="overline mb-3">Sign in</div>
          <h1 className="font-display text-4xl tracking-tighter leading-none mb-4">Welcome back.</h1>
          <p className="text-sm text-neutral-500 mb-8">
            Sign in with Microsoft. Works with personal Outlook/Hotmail accounts and organizational Entra accounts. Access is restricted to teammates added by the workspace owner.
          </p>

          {err && (
            <div className="mb-6 p-3 rounded-md border border-red-200 bg-red-50 text-sm text-red-900" data-testid="login-error">
              {err}
            </div>
          )}

          <button
            onClick={startLogin}
            data-testid="microsoft-login-btn"
            className="w-full flex items-center justify-center gap-3 px-4 py-3 bg-neutral-900 hover:bg-black text-white rounded-md transition-colors"
          >
            <MicrosoftOutlookLogo size={18} weight="bold" />
            <span className="font-medium">Continue with Microsoft</span>
          </button>

          <p className="text-xs text-neutral-500 mt-8">
            Not on the team yet? Ask the workspace owner to add your email on the Team page before signing in.
          </p>
        </div>
      </div>
    </div>
  );
}
